var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692,
    height: 552,
    viewBox: "0 0 692 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.104 -39.7946L438.171 -37.5366L338.165 140.251L442.146 315.706L646.079 313.411L746.086 135.661L642.104 -39.7946ZM628.164 283.142L459.408 285.083L373.379 139.878L456.124 -7.23033L624.879 -9.1338L710.89 136.034L628.164 283.142Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.829 122.299L408.798 -55.4889L304.816 -231L100.884 -228.667L0.914429 -50.9168L104.859 124.538L308.829 122.299ZM118.78 -198.417L287.611 -200.321L373.584 -55.1156L290.876 91.9928L122.102 93.9336L36.1286 -51.3087L118.78 -198.417Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.325 162.72L5.33716 340.47L109.282 516L313.251 513.705L413.221 335.917L309.258 160.387L105.325 162.72ZM295.28 483.417L126.506 485.358L40.4954 340.078L123.222 193.007L292.033 191.048L378.007 336.29L295.28 483.417Z",
    fill: "#EE1A25",
    fillOpacity: 0.13
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 692,
    height: 552,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImg1);
export default __webpack_public_path__ + "static/media/hero-img-1.ec56079dd6fa0bb8e8d6b2a5e8ac296f.svg";
export { ForwardRef as ReactComponent };